"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenFragments = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIs = require("react-is");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

const flattenFragments = (children, ChildWrapper, depth = 0) =>
// @ts-ignore
React.Children.toArray(children).reduce((acc, child, i) => {
  if ((0, _reactIs.isFragment)(child)) {
    acc.push(...flattenFragments(child.props.children, ChildWrapper, depth + 1));
  } else if ( /*#__PURE__*/React.isValidElement(child)) {
    if (ChildWrapper) {
      acc.push( /*#__PURE__*/React.createElement(ChildWrapper, {
        key: `${depth}.${i}`
      }, child));
    } else {
      acc.push(child);
    }
  }
  return acc;
}, []);
exports.flattenFragments = flattenFragments;